<template>
  <div>
    <b-modal
      v-model="inputVal.modal"
      :title="title"
      header-class="approval-modal__header"
      centered
      hide-footer
      no-enforce-focus
    >
      <div class="container">
        <div class="row">
          <WithdrawalModalText aria-hidden="true"></WithdrawalModalText>
          <div>
              <p class="withdrawal-disalbe" v-if="isNotEnoughProfit">
                <b-icon-exclamation-circle></b-icon-exclamation-circle>
                <template v-if="overview.available < 1000">
                    現時銷售收益未達港幣$1,000，未能申請收款。
                </template>
                <template v-else>
                    已於截數日前(每月20號23:59)申請收款，收款功能將於下個截數日後再次開啟。
                </template>
              </p>
            <p>現時可收取款項 HKD $ {{overview.available}}</p>
            <div v-if="isAllowWithdraw">
              <div class="divider"></div>
              <b-form-checkbox
                id="checkbox-1"
                v-model="isAgreeDisclaimer"
              >
                本人/本公司已詳細閱讀及同意U Lifestyle的收款申請條款，以及授權U Lifestyle於旗下網站及應用程式發佈已審批的相關優惠。
              </b-form-checkbox>
          </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-button variant="outline-secondary"
                      :disabled="loading"
                      @click="inputVal.modal = false">
              取消
            </b-button>
            <b-button
              variant="success"
              v-if="isAllowWithdraw && isAgreeDisclaimer"
              @click="prepareConfirm('CONFIRM')"
            >
              申請
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <WithdrawConfirmModal v-model="withdrawConfirmModal"
                      :onWithdrawSubmit="onWithdrawSubmit$"
                      :isAllowWithdraw="isAllowWithdraw"
                      :overview="overview"
                      :loading="loading"
                      @confirmSuccess="confirmSuccess"
    ></WithdrawConfirmModal>
    <WithdrawSuccessModal v-model="withdrawSuccessModal"></WithdrawSuccessModal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  BIconExclamationCircle,
  BFormCheckbox,
} from 'bootstrap-vue';
import { tap, switchMap } from 'rxjs/operators';
import WithdrawConfirmModal from '@/components/record/WithdrawConfirmModal.vue';
import WithdrawSuccessModal from '@/components/record/WithdrawSuccessModal.vue';
import WithdrawalModalText from '@/components/record/WithdrawalModalText.vue';
import { getErrorMsg } from '@/helpers/error-msg';
import vModelMixin from '../../mixins/v-model';
import http from '../../helpers/http';
import toastSettings from '../../helpers/toast-settings';

export default {
  mixins: [vModelMixin],
  props: {
    withdrawIsAllowModal: {
      type: Object,
    },
    overview: {
      type: Object,
    },
  },
  data: () => ({
    init: {
      quickbars_insert_toolbar: false,
      height: '250',
    },
    withdrawConfirmModal: {
      modal: false,
      action: null,
      remarks: null,
    },
    withdrawSuccessModal: {
      modal: false,
      action: null,
      remarks: null,
      back: {
        location: '/paymentRecords',
        text: '返回收款狀態',
      },
      msg: '我們正在處理中，謝謝。',
    },
    loading: false,
    isAgreeDisclaimer: false,
  }),
  components: {
    BButton,
    BModal,
    BIconExclamationCircle,
    WithdrawConfirmModal,
    WithdrawSuccessModal,
    WithdrawalModalText,
    BFormCheckbox,
  },
  computed: {
    title() {
      return '收款申請';
    },
    isAllowWithdraw() {
      return this.overview.status.isAllow;
    },
    isNotEnoughProfit() {
      return !this.overview.status.isAllow && !this.overview.status.hasPendingWithdrawal;
    },
  },
  domStreams: ['onWithdrawSubmit$'],
  subscriptions() {
    return {
      withdrawSubmit: this.onWithdrawSubmit$.pipe(
        tap(() => {
          this.loading = true;
        }),
        switchMap(() => http({
          method: 'POST',
          url: '/agc-merchant-api/paymentrecord/withdraw',
          data: {
            amount: this.overview.available,
          },
        }, {
          error: ({ data: { msg } }) => {
            this.$bvToast.toast(getErrorMsg(msg), {
              ...toastSettings,
              title: '錯誤',
              toaster: 'b-toaster-top-center',
            });
          },
          next: () => {
            this.withdrawConfirmModal.modal = false;
            this.withdrawSuccessModal.modal = true;
            this.overview.pending = this.overview.available;
            this.overview.available = 0;
            this.overview.status.isAllow = false;
            this.overview.status.hasPendingWithdrawal = true;
          },
          complete: () => {
            this.loading = false;
          },
        })),
      ),
    };
  },
  methods: {
    prepareConfirm(action) {
      this.withdrawConfirmModal = {
        modal: true,
        action,
        remarks: null,
      };
      this.inputVal.modal = false;
    },
    confirmSuccess() {
      this.withdrawConfirmModal.modal = false;
      this.withdrawSuccessModal.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .modal {
    &-dialog {
      max-width: 800px;
    }

    &-header {
      padding: 24px;
      border: none;
    }

    &-title {
      margin: 0 auto;
      font-size: 18px;
      font-weight: 400;
      color: #3a4047;
    }

    &-header .close {
      margin-left: -52px;
      margin-top: -12px;
      font-size: 20px;
    }

    &-body {
      padding: 0 24px 24px 24px;
    }

    &-body .col-12 {
      padding: 0;
      text-align: right;
    }

    .btn {
      margin-top: 24px;
      margin-left: 12px;
      width: 115px;
      padding: 10px 16px;

      &-success {
        background-color: #36b674 !important;
        border-color: #36b674 !important;
      }

      &-outline-secondary {
        background-color: #f9f9fa !important;
        border: 1px solid #dde1e5 !important;

        &:hover {
          background-color: #636d77 !important;
          border: 1px solid #636d77 !important;
        }
      }
    }

    p {
      font-size:15px;
    }

    p.withdrawal-disalbe{
      color:red;
      font-size:0.85em;
    }

    .divider{
      width:100%;
      background: #ccc;
      height:1px;
      margin-bottom:10px;
    }
  }
}
</style>
